import { MdDelete } from "react-icons/md";

const CommentCard = ({ el, user, deleteComment, handleReply, i, id }) => {
  return (
    <>
      <div className="flex justify-between">
        <p className="inline-flex items-center ">
          <img
            alt="blog"
            src={el.user_id.avatar}
            className="w-8 h-8 rounded-full flex-shrink-0 object-cover object-center"
          />
          <span className="flex-grow flex flex-col pl-3">
            <span className="title-font font-medium text-gray-900 dark:text-white">
              {el.user_id.name}
            </span>
            <span className="text-[16px] text-gray-600 dark:text-gray-400">
              {el.createdAt.substring(0, 10)}
            </span>
          </span>
        </p>
        {el.user_id.email === user?.user?.email ? (
          <MdDelete
            className="cursor-pointer text-2xl dark:text-white"
            onClick={() => deleteComment(el._id, id)}
          />
        ) : (
          ""
        )}
      </div>

      <p className="dark:text-white">{el.message}</p>
      <div
        className="text-[12px] cursor-pointer mt-4 w-[20px] text-gray-500 font-medium"
        onClick={() => handleReply(i)}
      >
        <p className="dark:text-gray-400">REPLY</p>
      </div>
    </>
  );
};

export default CommentCard;
